// OLIVIUM · Signal — live audit feed.
// Mounted inside the Square Code shell. Uses useAuditFeed.

import MetricCard from '../../components/MetricCard'
import EventRow from '../../components/EventRow'
import EmptyState from '../../components/EmptyState'
import { useAuditFeed } from '../../hooks/useAuditFeed'

export default function OliviumFeed() {
  const { events, stats, loading, authRequired } = useAuditFeed()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
      <Header />

      <section style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 14 }}>
        <MetricCard label="Total"     value={stats.total}     sub="events in memory" />
        <MetricCard label="Critical"  value={stats.criticals} sub="high severity" tone={stats.criticals ? 'critical' : 'default'} />
        <MetricCard label="Warnings"  value={stats.warnings}  sub="watch list"    tone={stats.warnings ? 'warning' : 'default'} />
        <MetricCard label="Denied"    value={stats.denials}   sub="blocked actions" tone={stats.denials ? 'warning' : 'default'} />
      </section>

      <section
        style={{
          border: '1px solid rgba(255,255,255,0.08)',
          background: 'rgba(255,255,255,0.035)',
          borderRadius: 18,
          overflow: 'hidden',
        }}
      >
        {authRequired ? (
          <div style={{ padding: 24 }}>
            <EmptyState
              title="Sign in to view Signal"
              body="OLIVIUM Signal reads the live audit trail and requires an authenticated operator session."
            />
          </div>
        ) : loading ? (
          <div style={{ padding: 24 }}>
            <EmptyState title="Loading feed" body="Hydrating OLIVIUM signal." />
          </div>
        ) : events.length === 0 ? (
          <div style={{ padding: 24 }}>
            <EmptyState title="No events yet" body="The audit trail is empty." />
          </div>
        ) : (
          events.map((event) => <EventRow key={event.id} event={event} />)
        )}
      </section>
    </div>
  )
}

function Header() {
  return (
    <div>
      <div
        style={{
          fontSize: 11,
          color: '#7f8db4',
          fontFamily: 'var(--font-mono)',
          letterSpacing: '0.16em',
          marginBottom: 6,
        }}
      >
        OLIVIUM · SIGNAL
      </div>
      <h1
        style={{
          fontSize: 24,
          fontWeight: 700,
          margin: 0,
          color: '#edf2ff',
          fontFamily: 'var(--font-brand)',
        }}
      >
        Live Audit Stream
      </h1>
      <div style={{ fontSize: 13, color: '#97a7cf', marginTop: 4 }}>
        Realtime trust signal. Click any row to inspect in the right panel.
      </div>
    </div>
  )
}
